import { HubsSettingClient, HubUserAttributesClient } from 'frontend-preferences-client';
import { useCallback, useState } from 'react';
import { useAsyncEffect } from 'react-utils/hooks/useAsyncEffect';
import Raven from 'raven-js';
const hubSettingsClient = HubsSettingClient.forCaller('growth-payments-core');
const hubUserAttributesClient = HubUserAttributesClient.forCaller('growth-payments-core');
export const useFrontendPreference = (client, key, defaultValue, valueProcessorFn, skipFetch = false) => {
  const [value, setValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const processResponse = useCallback(response => {
    if (valueProcessorFn) {
      setValue(valueProcessorFn(response));
    } else {
      setValue(response);
    }
  }, [valueProcessorFn]);
  const fetchAndStoreUserAttribute = useCallback(async () => {
    setIsLoading(true);
    try {
      const result = await client.fetch(key, defaultValue || '');
      processResponse(result);
    } catch (e) {
      Raven.captureException(e);
    } finally {
      setIsLoading(false);
    }
  }, [key, defaultValue, client, processResponse]);
  const updateUserAttributeValue = useCallback(async newValue => {
    try {
      const result = await client.write(key, newValue);
      processResponse(result);
    } catch (e) {
      Raven.captureException(e);
    }
  }, [client, key, processResponse]);
  useAsyncEffect(async () => {
    if (!skipFetch) {
      await fetchAndStoreUserAttribute();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skipFetch]);
  return [value, updateUserAttributeValue, isLoading];
};
export const useHubSetting = (...args) => useFrontendPreference(hubSettingsClient, ...args);
export const useHubUserAttribute = (...args) => useFrontendPreference(hubUserAttributesClient, ...args);